/* eslint-disable react/jsx-indent */
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import useEvents from '../../../hooks/useEvents';

import { useEdition, useMenus } from '../../../contexts/SiteContext';
import StyledButton from '../../buttons/StyledButton';
import ProEvent from '../../cards/ProEvent';
import Loader from '../../partials/Loader';
import PageMeta from '../../partials/PageMeta';
import Sidebar from '../../partials/Sidebar';

import styles from '../../../../styles/pages/pro.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function ProHomePage({ page = null }) {
    const { pro } = useMenus();
    const edition = useEdition();
    const { mediaKitUrl = null } = edition || {};

    const { title = null } = page || {};
    const { data: events = null, isLoading = false } = useEvents({ query: { self: true } });
    const getUrlFromItem = useCallback((item) => item?.internalUrl, []);
    const hasEvents = events !== null && events.length > 0;

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Sidebar className={styles.sidebar} menu={pro} title={title}>
                <div>
                    {mediaKitUrl !== null ? (
                        <StyledButton href={mediaKitUrl} external size="small">
                            <FormattedMessage
                                defaultMessage="Download media kit"
                                description="Button label"
                            />
                        </StyledButton>
                    ) : null}
                    <div className={styles.spacer} />
                    <div className={styles.gridFlat}>
                        {hasEvents
                            ? (events || []).map((evt) => (
                                  <ProEvent
                                      className={styles.item}
                                      key={`evt-${evt?.id}`}
                                      item={evt}
                                      getUrlFromItem={getUrlFromItem}
                                  />
                              ))
                            : null}
                    </div>
                    {!hasEvents && !isLoading ? (
                        <p>
                            <FormattedMessage
                                defaultMessage="No events yet! Start by making an order for a film."
                                description="Help text"
                            />
                        </p>
                    ) : null}
                    {isLoading ? <Loader /> : null}
                </div>
            </Sidebar>
        </div>
    );
}

ProHomePage.propTypes = propTypes;

export default ProHomePage;
